import { environment, SiteMode } from './api';

export class Paths {
    static requestAccess =
        environment.site.mode === SiteMode.PartnerApis
            ? 'https://docs.google.com/forms/d/e/1FAIpQLSe94x8HjT2uKg5giU9cJNDkCtQoHWEP6_bYKU6QTlkcx4IywQ/viewform'
            : '/request-access';

    static customerIntegrationPaths = '/integration-paths';
}

/**
 * Determines whether a specified path can be handled by React Router.
 * @param path A local path starting with a slash or an absolute URL starting with a scheme like `https://`.
 */
export function isLocalPath(path: string): boolean {
    return path.startsWith('/');
}
